import { Layout } from 'src/viewLayer/components/DesignSystem';

import { getDisplayLanguageItems } from './displayLanguageItems';
import { t } from 'src/viewLayer/helpers/translations';
import Dropdown from './Dropdown';

export default (): JSX.Element => {
  const languageItems = getDisplayLanguageItems();

  return (
    <Layout alignItems="center" gap={16}>
      {t('pages.content.i_speak')}
      <Dropdown languageItems={languageItems} />
    </Layout>
  );
};
